export function getFormFieldInputId(field: { form: { formId: string }; name: string }) {
  return `${field.form.formId}-${field.name}`;
}
